/** Wrap-up agent status names - must match the entries in InternalAgentStatuses in service/agent_status.go. */
export const INBOUND_WRAP_UP = "Inbound Wrap Up";
export const OUTBOUND_WRAP_UP = "Outbound Wrap Up";
export const WRAP_UP_AGENT_STATUSES: string[] = [INBOUND_WRAP_UP, OUTBOUND_WRAP_UP];
